import {toggle} from 'opticks/lib/optimizely'

import {brands, defaultBrand} from '@daedalus/core/src/brand/config'
import {useAuth} from '@daedalus/core/src/auth/components/AuthProvider'
import {AuthContextType} from '@daedalus/core/src/auth/types/Auth'
import {
  UseCognitoType,
  getIsMemberPlus
} from '@daedalus/core/src/auth/modules/useCognito'

const useToggleAuth = () => {
  const auth0Values = useAuth()
  const isMemberPlus = getIsMemberPlus()

  return toggle('f54ef0b3-cognito-auth', auth0Values, {
    isMemberPlus
  }) as Partial<AuthContextType> | Pick<UseCognitoType, 'isMemberPlus'>
}

export const useIsReferralProgramEnabled = (brand = defaultBrand) => {
  const {isMemberPlus} = useToggleAuth()
  const isNotEtrip = brands.etrip.name !== brand.name
  const isReferralProgramEnabled = toggle(
    '3ed28581-referral-program',
    false,
    true
  ) as boolean

  return isReferralProgramEnabled && isMemberPlus && isNotEtrip
}
